/* eslint-disable */
export default {
    'pageSize': 10,
    'pageSizes': [10, 20, 30, 50, 100],
    // 表格头部的样式
    'headerRowStyle': {
        color: '#5C5F66',
        fontSize: '14px'
    },
    // 头部单元格提示
    'headerCellStyle': {
        background: '#F5F6FA',
        fontWeight: 'normal',
        height: '40px',
        padding: '0 12px',
        borderBottom: 0,
        borderRight: '1px solid #FFFFFF',
    },
    'selectionHeaderCellStyle': {
        background: '#F5F6FA',
        fontWeight: 'normal',
        height: '40px',
        padding: '0 0 0 12px',
        borderBottom: 0,
        borderRight: 'none'
        // borderRight: '1px solid #FFFFFF'
    },
    // 所有单元格的样式
    'cellStyle': {
        // border: 'none',
        borderRight: 'none',
        borderColor: 'rgba(13, 13, 13, 0.06)',
        color: '#151B26',
        fontSize: '14px',
        height: '50px',
        padding: '0 12px',
    },
    'selectioncellStyle': {
        // border: 'none',
        borderColor: 'rgba(13, 13, 13, 0.06)',
        borderRight: 'none',
        color: '#151B26',
        fontSize: '14px',
        height: '50px',
        padding: '0 0 0 12px',
    },
    changeColWidth: function (newWidth, oldWidth, column, event) {
        return new Promise((resolve) => {
            if (column.width < column.minWidth) {
                column.width = column.minWidth
            }
            resolve()
        })
    }
}